"use no memo";
import { css } from "@emotion/react";
import React from "react";

const iconWrapCSS = css`
  display: inline-flex;
  flex-shrink: 0;
`;

/**
 * Icons from https://icons.lobehub.com/
 */
const AzureSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Azure</title>
    <path d="M11.49 2H2v9.492h9.492V2h-.002z" fill="#F25022"></path>
    <path d="M22 2h-9.492v9.492H22V2z" fill="#7FBA00"></path>
    <path d="M11.49 12.508H2V22h9.492v-9.492h-.002z" fill="#00A4EF"></path>
    <path d="M22 12.508h-9.492V22H22v-9.492z" fill="#FFB900"></path>
  </svg>
);
const GoogleSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Google</title>
    <defs>
      <linearGradient
        id="lobe-icons-google-fill"
        x1="0%"
        x2="68.73%"
        y1="100%"
        y2="30.395%"
      >
        <stop offset="0%" stopColor="#1C7DFF"></stop>
        <stop offset="52.021%" stopColor="#1C69FF"></stop>
        <stop offset="100%" stopColor="#F0DCD6"></stop>
      </linearGradient>
    </defs>
    <path
      d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12"
      fill="url(#lobe-icons-google-fill)"
      fillRule="nonzero"
    ></path>
  </svg>
);

const OpenAISVG = ({ height }: { height: number }) => (
  <svg
    fill="var(--global-text-color-900)"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>OpenAI</title>
    <path d="M21.55 10.004a5.416 5.416 0 00-.478-4.501c-1.217-2.09-3.662-3.166-6.05-2.66A5.59 5.59 0 0010.831 1C8.39.995 6.224 2.546 5.473 4.838A5.553 5.553 0 001.76 7.496a5.487 5.487 0 00.691 6.5 5.416 5.416 0 00.477 4.502c1.217 2.09 3.662 3.165 6.05 2.66A5.586 5.586 0 0013.168 23c2.443.006 4.61-1.546 5.361-3.84a5.553 5.553 0 003.715-2.66 5.488 5.488 0 00-.693-6.497v.001zm-8.381 11.558a4.199 4.199 0 01-2.675-.954c.034-.018.093-.05.132-.074l4.44-2.53a.71.71 0 00.364-.623v-6.176l1.877 1.069c.02.01.033.029.036.05v5.115c-.003 2.274-1.87 4.118-4.174 4.123zM4.192 17.78a4.059 4.059 0 01-.498-2.763c.032.02.09.055.131.078l4.44 2.53c.225.13.504.13.73 0l5.42-3.088v2.138a.068.068 0 01-.027.057L9.9 19.288c-1.999 1.136-4.552.46-5.707-1.51h-.001zM3.023 8.216A4.15 4.15 0 015.198 6.41l-.002.151v5.06a.711.711 0 00.364.624l5.42 3.087-1.876 1.07a.067.067 0 01-.063.005l-4.489-2.559c-1.995-1.14-2.679-3.658-1.53-5.63h.001zm15.417 3.54l-5.42-3.088L14.896 7.6a.067.067 0 01.063-.006l4.489 2.557c1.998 1.14 2.683 3.662 1.529 5.633a4.163 4.163 0 01-2.174 1.807V12.38a.71.71 0 00-.363-.623zm1.867-2.773a6.04 6.04 0 00-.132-.078l-4.44-2.53a.731.731 0 00-.729 0l-5.42 3.088V7.325a.068.068 0 01.027-.057L14.1 4.713c2-1.137 4.555-.46 5.707 1.513.487.833.664 1.809.499 2.757h.001zm-11.741 3.81l-1.877-1.068a.065.065 0 01-.036-.051V6.559c.001-2.277 1.873-4.122 4.181-4.12.976 0 1.92.338 2.671.954-.034.018-.092.05-.131.073l-4.44 2.53a.71.71 0 00-.365.623l-.003 6.173v.002zm1.02-2.168L12 9.25l2.414 1.375v2.75L12 14.75l-2.415-1.375v-2.75z"></path>
  </svg>
);

const AnthropicSVG = ({ height }: { height: number }) => (
  <svg
    fill="var(--global-text-color-900)"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Anthropic</title>
    <path d="M13.827 3.52h3.603L24 20h-3.603l-6.57-16.48zm-7.258 0h3.767L16.906 20h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm4.132 9.959L8.453 7.687 6.205 13.48H10.7z"></path>
  </svg>
);

const DeepSeekSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>DeepSeek</title>
    <path
      d="M23.748 4.482c-.254-.124-.364.113-.512.234-.051.039-.094.09-.137.136-.372.397-.806.657-1.373.626-.829-.046-1.537.214-2.163.848-.133-.782-.575-1.248-1.247-1.548-.352-.156-.708-.311-.955-.65-.172-.241-.219-.51-.305-.774-.055-.16-.11-.323-.293-.35-.2-.031-.278.136-.356.276-.313.572-.434 1.202-.422 1.84.027 1.436.633 2.58 1.838 3.393.137.093.172.187.129.323-.082.28-.18.552-.266.833-.055.179-.137.217-.329.14a5.526 5.526 0 01-1.736-1.18c-.857-.828-1.631-1.742-2.597-2.458a11.365 11.365 0 00-.689-.471c-.985-.957.13-1.743.388-1.836.27-.098.093-.432-.779-.428-.872.004-1.67.295-2.687.684a3.055 3.055 0 01-.465.137 9.597 9.597 0 00-2.883-.102c-1.885.21-3.39 1.102-4.497 2.623C.082 8.606-.231 10.684.152 12.85c.403 2.284 1.569 4.175 3.36 5.653 1.858 1.533 3.997 2.284 6.438 2.14 1.482-.085 3.133-.284 4.994-1.86.47.234.962.327 1.78.397.63.059 1.236-.03 1.705-.128.735-.156.684-.837.419-.961-2.155-1.004-1.682-.595-2.113-.926 1.096-1.296 2.746-2.642 3.392-7.003.05-.347.007-.565 0-.845-.004-.17.035-.237.23-.256a4.173 4.173 0 001.545-.475c1.396-.763 1.96-2.015 2.093-3.517.02-.23-.004-.467-.247-.588zM11.581 18c-2.089-1.642-3.102-2.183-3.52-2.16-.392.024-.321.471-.235.763.09.288.207.486.371.739.114.167.192.416-.113.603-.673.416-1.842-.14-1.897-.167-1.361-.802-2.5-1.86-3.301-3.307-.774-1.393-1.224-2.887-1.298-4.482-.02-.386.093-.522.477-.592a4.696 4.696 0 011.529-.039c2.132.312 3.946 1.265 5.468 2.774.868.86 1.525 1.887 2.202 2.891.72 1.066 1.494 2.082 2.48 2.914.348.292.625.514.891.677-.802.09-2.14.11-3.054-.614zm1-6.44a.306.306 0 01.415-.287.302.302 0 01.2.288.306.306 0 01-.31.307.303.303 0 01-.304-.308zm3.11 1.596c-.2.081-.399.151-.59.16a1.245 1.245 0 01-.798-.254c-.274-.23-.47-.358-.552-.758a1.73 1.73 0 01.016-.588c.07-.327-.008-.537-.239-.727-.187-.156-.426-.199-.688-.199a.559.559 0 01-.254-.078c-.11-.054-.2-.19-.114-.358.028-.054.16-.186.192-.21.356-.202.767-.136 1.146.016.352.144.618.408 1.001.782.391.451.462.576.685.914.176.265.336.537.445.848.067.195-.019.354-.25.452z"
      fill="#4D6BFE"
    ></path>
  </svg>
);

const XAISVG = ({ height }: { height: number }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>xAI</title>
    <path d="M6.469 8.776L16.512 23h-4.464L2.005 8.776H6.47zm-.004 7.9l2.233 3.164L6.467 23H2l4.465-6.324zM22 2.582V23h-3.659V7.764L22 2.582zM22 1l-9.952 14.095-2.233-3.163L17.533 1H22z"></path>
  </svg>
);

const OllamaSVG = ({ height }: { height: number }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    height={height}
    viewBox="0 0 24 24"
    width={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Ollama</title>
    <path d="M7.905 1.09c.216.085.411.225.588.41.295.306.544.744.734 1.263.191.522.315 1.1.362 1.68a5.054 5.054 0 012.049-.636l.051-.004c.87-.07 1.73.087 2.48.474.101.053.2.11.297.17.05-.569.172-1.134.36-1.644.19-.52.439-.957.733-1.264a1.67 1.67 0 01.589-.41c.257-.1.53-.118.796-.042.401.114.745.368 1.016.737.248.337.434.769.561 1.287.23.934.27 2.163.115 3.645l.053.04.026.019c.757.576 1.284 1.397 1.563 2.35.435 1.487.216 3.155-.534 4.088l-.018.021.002.003c.417.762.67 1.567.724 2.4l.002.03c.064 1.065-.2 2.137-.814 3.19l-.007.01.01.024c.472 1.157.62 2.322.438 3.486l-.006.039a.651.651 0 01-.747.536.648.648 0 01-.54-.742c.167-1.033.01-2.069-.48-3.123a.643.643 0 01.04-.617l.004-.006c.604-.924.854-1.83.8-2.72-.046-.779-.325-1.544-.8-2.273a.644.644 0 01.18-.886l.009-.006c.243-.159.467-.565.58-1.12a4.229 4.229 0 00-.095-1.974c-.205-.7-.58-1.284-1.105-1.683-.595-.454-1.383-.673-2.38-.61a.653.653 0 01-.632-.371c-.314-.665-.772-1.141-1.343-1.436a3.288 3.288 0 00-1.772-.332c-1.245.099-2.343.801-2.67 1.686a.652.652 0 01-.61.425c-1.067.002-1.893.252-2.497.703-.522.39-.878.935-1.066 1.588a4.07 4.07 0 00-.068 1.886c.112.558.331 1.02.582 1.269l.008.007c.212.207.257.53.109.785-.36.622-.629 1.549-.673 2.44-.05 1.018.186 1.902.719 2.536l.016.019a.643.643 0 01.095.69c-.576 1.236-.753 2.252-.562 3.052a.652.652 0 01-1.269.298c-.243-1.018-.078-2.184.473-3.498l.014-.035-.008-.012a4.339 4.339 0 01-.598-1.309l-.005-.019a5.764 5.764 0 01-.177-1.785c.044-.91.278-1.842.622-2.59l.012-.026-.002-.002c-.293-.418-.51-.953-.63-1.545l-.005-.024a5.352 5.352 0 01.093-2.49c.262-.915.777-1.701 1.536-2.269.06-.045.123-.09.186-.132-.159-1.493-.119-2.73.112-3.67.127-.518.314-.95.562-1.287.27-.368.614-.622 1.015-.737.266-.076.54-.059.797.042zm4.116 9.09c.936 0 1.8.313 2.446.855.63.527 1.005 1.235 1.005 1.94 0 .888-.406 1.58-1.133 2.022-.62.375-1.451.557-2.403.557-1.009 0-1.871-.259-2.493-.734-.617-.47-.963-1.13-.963-1.845 0-.707.398-1.417 1.056-1.946.668-.537 1.55-.849 2.485-.849zm0 .896a3.07 3.07 0 00-1.916.65c-.461.37-.722.835-.722 1.25 0 .428.21.829.61 1.134.455.347 1.124.548 1.943.548.799 0 1.473-.147 1.932-.426.463-.28.7-.686.7-1.257 0-.423-.246-.89-.683-1.256-.484-.405-1.14-.643-1.864-.643zm.662 1.21l.004.004c.12.151.095.37-.056.49l-.292.23v.446a.375.375 0 01-.376.373.375.375 0 01-.376-.373v-.46l-.271-.218a.347.347 0 01-.052-.49.353.353 0 01.494-.051l.215.172.22-.174a.353.353 0 01.49.051zm-5.04-1.919c.478 0 .867.39.867.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zm8.706 0c.48 0 .868.39.868.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zM7.44 2.3l-.003.002a.659.659 0 00-.285.238l-.005.006c-.138.189-.258.467-.348.832-.17.692-.216 1.631-.124 2.782.43-.128.899-.208 1.404-.237l.01-.001.019-.034c.046-.082.095-.161.148-.239.123-.771.022-1.692-.253-2.444-.134-.364-.297-.65-.453-.813a.628.628 0 00-.107-.09L7.44 2.3zm9.174.04l-.002.001a.628.628 0 00-.107.09c-.156.163-.32.45-.453.814-.29.794-.387 1.776-.23 2.572l.058.097.008.014h.03a5.184 5.184 0 011.466.212c.086-1.124.038-2.043-.128-2.722-.09-.365-.21-.643-.349-.832l-.004-.006a.659.659 0 00-.285-.239h-.004z"></path>
  </svg>
);
const BedrockSVG = ({ height }: { height: number }) => (
  <svg
    width={height}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.4425L8.66425 21.5548L7.3635 20.6872L8.77975 20.2142L8.34525 18.9107L5.91425 19.7206L5.125 19.1953V15.4374C5.125 15.1775 4.97788 14.9396 4.7455 14.8227L2.375 13.6375V10.3621L4.4375 9.33087L6.5 10.3621V12.6873C6.5 12.9486 6.64713 13.1864 6.8795 13.3033L9.6295 14.6783L10.2455 13.4477L7.875 12.2624V10.3621L10.2455 9.17824C10.4779 9.06136 10.625 8.82349 10.625 8.56223V6.49969H9.25V8.13735L7.1875 9.16862L5.125 8.13735V4.80566L6.5 3.88852V6.49969H7.875V2.97275L8.66425 2.44612L12 3.55851V20.4425ZM19.5625 18.8749C19.9406 18.8749 20.25 19.1829 20.25 19.5624C20.25 19.9419 19.9406 20.2499 19.5625 20.2499C19.1844 20.2499 18.875 19.9419 18.875 19.5624C18.875 19.1829 19.1844 18.8749 19.5625 18.8749ZM18.1875 3.74964C18.5656 3.74964 18.875 4.05765 18.875 4.43715C18.875 4.81666 18.5656 5.12467 18.1875 5.12467C17.8094 5.12467 17.5 4.81666 17.5 4.43715C17.5 4.05765 17.8094 3.74964 18.1875 3.74964ZM20.9375 11.9998C21.3156 11.9998 21.625 12.3078 21.625 12.6873C21.625 13.0668 21.3156 13.3748 20.9375 13.3748C20.5594 13.3748 20.25 13.0668 20.25 12.6873C20.25 12.3078 20.5594 11.9998 20.9375 11.9998ZM19.0015 13.3748C19.2861 14.1737 20.0424 14.7498 20.9375 14.7498C22.0746 14.7498 23 13.8258 23 12.6873C23 11.5502 22.0746 10.6248 20.9375 10.6248C20.0424 10.6248 19.2861 11.2023 19.0015 11.9998H13.375V9.24974H18.1875C18.567 9.24974 18.875 8.94311 18.875 8.56223V6.37319C19.6739 6.08856 20.25 5.3323 20.25 4.43715C20.25 3.30001 19.3246 2.37462 18.1875 2.37462C17.0504 2.37462 16.125 3.30001 16.125 4.43715C16.125 5.3323 16.7011 6.08856 17.5 6.37319V7.87472H13.375V3.06213C13.375 2.7665 13.1853 2.50387 12.9048 2.41037L8.77975 1.03534C8.57763 0.967964 8.35763 0.998214 8.18163 1.11509L4.05663 3.86514C3.8655 3.99302 3.75 4.20752 3.75 4.43715V8.13735L1.3795 9.32262C1.14713 9.4395 1 9.67738 1 9.93726V14.0623C1 14.3236 1.14713 14.5615 1.3795 14.6783L3.75 15.8622V19.5624C3.75 19.7921 3.8655 20.0079 4.05663 20.1344L8.18163 22.8845C8.29575 22.9615 8.42775 23 8.5625 23C8.63538 23 8.70825 22.989 8.77975 22.9642L12.9048 21.5892C13.1853 21.4971 13.375 21.2345 13.375 20.9375V17.4999H16.5279L17.7008 18.6742L17.7186 18.6563C17.5839 18.9313 17.5 19.2366 17.5 19.5624C17.5 20.6996 18.4254 21.625 19.5625 21.625C20.6996 21.625 21.625 20.6996 21.625 19.5624C21.625 18.4253 20.6996 17.4999 19.5625 17.4999C19.2353 17.4999 18.93 17.5838 18.6564 17.7199L18.6743 17.702L17.2993 16.327C17.17 16.1977 16.9954 16.1249 16.8125 16.1249H13.375V13.3748H19.0015Z"
      fill="currentColor"
    />
  </svg>
);

const CerebrasSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Cerebras</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1211,2.701 C11.6547,2.701 9.2895,3.6807 7.5456,5.4246 C5.8017,7.1685 4.822,9.5337 4.822,12 C4.822,14.4663 5.8017,16.8315 7.5456,18.5753 C9.2895,20.3193 11.6547,21.2989 14.1211,21.2989 L14.1211,22.7 C8.211,22.7 3.421,17.9089 3.421,11.999 C3.421,6.089 8.21,1.299 14.12,1.299 L14.12,2.7 L14.1211,2.701 M18.8729,6.378 C18.1341,5.7508 17.2787,5.2759 16.3556,4.9805 C15.4327,4.6851 14.4603,4.5751 13.4947,4.6568 C12.529,4.7385 11.589,5.0102 10.7287,5.4565 C9.8684,5.9027 9.1048,6.5146 8.4819,7.257 C7.8589,7.9994 7.3888,8.8576 7.0987,9.7823 C6.8086,10.707 6.7041,11.6799 6.7913,12.6451 C6.8785,13.6103 7.1556,14.5487 7.6067,15.4064 C8.0578,16.2641 8.6741,17.0243 9.42,17.6429 L8.519,18.7169 C7.6381,17.9781 6.9114,17.0729 6.3804,16.0532 C5.8494,15.0335 5.5245,13.9191 5.4242,12.7737 C5.3239,11.6283 5.4502,10.4745 5.7959,9.3779 C6.1416,8.2814 6.6999,7.2637 7.439,6.383 C8.178,5.5021 9.0832,4.7754 10.1031,4.2444 C11.1229,3.7133 12.2374,3.3884 13.3828,3.2881 C14.5283,3.1878 15.6823,3.3141 16.7788,3.6599 C17.8755,4.0056 18.8932,4.5639 19.774,5.303 L18.8729,6.378 M16.618,7.222 C15.3513,6.5677 13.8775,6.4402 12.5173,6.8672 C11.1571,7.2942 10.0205,8.2411 9.355,9.5019 C8.6895,10.7627 8.5488,12.2353 8.9636,13.5993 C9.3785,14.9633 10.3152,16.1083 11.57,16.7849 L10.914,18.0249 C9.3467,17.1656 8.1801,15.7244 7.666,14.0124 C7.1519,12.3005 7.3315,10.4551 8.166,8.8744 C9.0005,7.2937 10.423,6.1044 12.1266,5.5633 C13.8303,5.0222 15.6783,5.1726 17.272,5.982 L16.618,7.222 M14.12,8.539 C13.2021,8.539 12.3218,8.9036 11.6727,9.5527 C11.0236,10.2018 10.659,11.0821 10.659,12 C10.659,12.9179 11.0236,13.7983 11.6727,14.4473 C12.3218,15.0964 13.2021,15.4609 14.12,15.4609 L14.12,16.8629 C12.8303,16.8629 11.5933,16.3507 10.6813,15.4387 C9.7693,14.5267 9.257,13.2897 9.257,12 C9.257,10.7102 9.7693,9.4733 10.6813,8.5613 C11.5933,7.6493 12.8303,7.137 14.12,7.137 L14.12,8.539"
      fill="#F15A29"
    />
    <path
      d="M15.4069,10.836 C15.2579,10.6755 15.0861,10.5377 14.8969,10.427 C14.7323,10.3292 14.5445,10.2767 14.3529,10.275 C14.098,10.275 13.87,10.322 13.6689,10.415 C13.4747,10.5025 13.3002,10.6284 13.1558,10.7852 C13.0114,10.9419 12.9003,11.1262 12.829,11.327 C12.755,11.53 12.719,11.743 12.719,11.958 C12.719,12.176 12.755,12.388 12.829,12.589 C12.9009,12.7896 13.0123,12.9738 13.1565,13.1306 C13.3008,13.2874 13.4751,13.4137 13.6689,13.502 C13.8689,13.5951 14.0989,13.642 14.3529,13.642 C14.5689,13.642 14.77,13.596 14.9549,13.5071 C15.1429,13.4171 15.3049,13.282 15.43,13.115 L16.358,14.1211 C16.218,14.2611 16.058,14.382 15.876,14.484 C15.5395,14.6717 15.1731,14.8003 14.7929,14.864 C14.6229,14.89 14.476,14.904 14.3529,14.904 C13.9495,14.9065 13.5489,14.8353 13.171,14.694 C12.8137,14.5619 12.4868,14.3588 12.21,14.0971 C11.9347,13.834 11.7157,13.518 11.566,13.168 C11.4034,12.7856 11.3223,12.3735 11.328,11.958 C11.328,11.514 11.408,11.111 11.566,10.748 C11.716,10.398 11.934,10.082 12.209,9.819 C12.487,9.558 12.814,9.355 13.171,9.223 C13.5489,9.0817 13.9495,9.0105 14.3529,9.013 C14.708,9.013 15.0649,9.081 15.4249,9.217 C15.786,9.355 16.11,9.577 16.3689,9.866 L15.4069,10.836"
      fill="currentColor"
    />
  </svg>
);

const FireworksSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Fireworks</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8,5 L11.999,11.795 L9.195,5 L7.397,5 L10.469,12.428 C10.5917,12.7301 10.8017,12.9888 11.0722,13.1709 C11.3426,13.3531 11.6612,13.4505 11.9873,13.4508 C12.3134,13.4509 12.6322,13.354 12.9028,13.1721 C13.1735,12.9903 13.3839,12.7319 13.5069,12.43 L16.598,5 L14.8,5 M15.996,15.352 L21.12,10.108 L20.4209,8.439 L14.8249,14.178 C14.5965,14.4121 14.4421,14.7084 14.3812,15.0299 C14.3201,15.3512 14.3552,15.6835 14.482,15.9849 C14.6064,16.2845 14.8169,16.5405 15.0867,16.7207 C15.3565,16.9008 15.6736,16.9969 15.998,16.9969 L16,17 L24,16.98 L23.3011,15.3109 L15.998,15.352 L15.996,15.352 M2.88,10.104 L3.579,8.435 L9.175,14.174 C9.643,14.6529 9.778,15.3629 9.518,15.9809 C9.3934,16.2805 9.183,16.5364 8.9132,16.7165 C8.6434,16.8965 8.3264,16.9928 8.002,16.9931 L0.002,16.9751 L0,16.9769 L0.699,15.308 L8.002,15.35 L2.88,10.104"
      fill="currentColor"
    />
  </svg>
);

const GroqSVG = ({ height }: { height: number }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Groq</title>
    <path d="M12.036 2c-3.853-.035-7 3-7.036 6.781-.035 3.782 3.055 6.872 6.908 6.907h2.42v-2.566h-2.292c-2.407.028-4.38-1.866-4.408-4.23-.029-2.362 1.901-4.298 4.308-4.326h.1c2.407 0 4.358 1.915 4.365 4.278v6.305c0 2.342-1.944 4.25-4.323 4.279a4.375 4.375 0 01-3.033-1.252l-1.851 1.818A7 7 0 0012.029 22h.092c3.803-.056 6.858-3.083 6.879-6.816v-6.5C18.907 4.963 15.817 2 12.036 2z"></path>
  </svg>
);

const MoonshotSVG = ({ height }: { height: number }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Moonshot</title>
    <path d="M1.052 16.916l9.539 2.552a21.007 21.007 0 00.06 2.033l5.956 1.593a11.997 11.997 0 01-5.586.865l-.18-.016-.044-.004-.084-.009-.094-.01a11.605 11.605 0 01-.157-.02l-.107-.014-.11-.016a11.962 11.962 0 01-.32-.051l-.042-.008-.075-.013-.107-.02-.07-.015-.093-.019-.075-.016-.095-.02-.097-.023-.094-.022-.068-.017-.088-.022-.09-.024-.095-.025-.082-.023-.109-.03-.062-.02-.084-.025-.093-.028-.105-.034-.058-.019-.08-.026-.09-.031-.066-.024a6.293 6.293 0 01-.044-.015l-.068-.025-.101-.037-.057-.022-.08-.03-.087-.035-.088-.035-.079-.032-.095-.04-.063-.028-.063-.027a5.655 5.655 0 01-.041-.018l-.066-.03-.103-.047-.052-.024-.096-.046-.062-.03-.084-.04-.086-.044-.093-.047-.052-.027-.103-.055-.057-.03-.058-.032a6.49 6.49 0 01-.046-.026l-.094-.053-.06-.034-.051-.03-.072-.041-.082-.05-.093-.056-.052-.032-.084-.053-.061-.039-.079-.05-.07-.047-.053-.035a7.785 7.785 0 01-.054-.036l-.044-.03-.044-.03a6.066 6.066 0 01-.04-.028l-.057-.04-.076-.054-.069-.05-.074-.054-.056-.042-.076-.057-.076-.059-.086-.067-.045-.035-.064-.052-.074-.06-.089-.073-.046-.039-.046-.039a7.516 7.516 0 01-.043-.037l-.045-.04-.061-.053-.07-.062-.068-.06-.062-.058-.067-.062-.053-.05-.088-.084a13.28 13.28 0 01-.099-.097l-.029-.028-.041-.042-.069-.07-.05-.051-.05-.053a6.457 6.457 0 01-.168-.179l-.08-.088-.062-.07-.071-.08-.042-.049-.053-.062-.058-.068-.046-.056a7.175 7.175 0 01-.027-.033l-.045-.055-.066-.082-.041-.052-.05-.064-.02-.025a11.99 11.99 0 01-1.44-2.402zm-1.02-5.794l11.353 3.037a20.468 20.468 0 00-.469 2.011l10.817 2.894a12.076 12.076 0 01-1.845 2.005L.657 15.923l-.016-.046-.035-.104a11.965 11.965 0 01-.05-.153l-.007-.023a11.896 11.896 0 01-.207-.741l-.03-.126-.018-.08-.021-.097-.018-.081-.018-.09-.017-.084-.018-.094c-.026-.141-.05-.283-.071-.426l-.017-.118-.011-.083-.013-.102a12.01 12.01 0 01-.019-.161l-.005-.047a12.12 12.12 0 01-.034-2.145zm1.593-5.15l11.948 3.196c-.368.605-.705 1.231-1.01 1.875l11.295 3.022c-.142.82-.368 1.612-.668 2.365l-11.55-3.09L.124 10.26l.015-.1.008-.049.01-.067.015-.087.018-.098c.026-.148.056-.295.088-.442l.028-.124.02-.085.024-.097c.022-.09.045-.18.07-.268l.028-.102.023-.083.03-.1.025-.082.03-.096.026-.082.031-.095a11.896 11.896 0 011.01-2.232zm4.442-4.4L17.352 4.59a20.77 20.77 0 00-1.688 1.721l7.823 2.093c.267.852.442 1.744.513 2.665L2.106 5.213l.045-.065.027-.04.04-.055.046-.065.055-.076.054-.072.064-.086.05-.065.057-.073.055-.07.06-.074.055-.069.065-.077.054-.066.066-.077.053-.06.072-.082.053-.06.067-.074.054-.058.073-.078.058-.06.063-.067.168-.17.1-.098.059-.056.076-.071a12.084 12.084 0 012.272-1.677zM12.017 0h.097l.082.001.069.001.054.002.068.002.046.001.076.003.047.002.06.003.054.002.087.005.105.007.144.011.088.007.044.004.077.008.082.008.047.005.102.012.05.006.108.014.081.01.042.006.065.01.207.032.07.012.065.011.14.026.092.018.11.022.046.01.075.016.041.01L14.7.3l.042.01.065.015.049.012.071.017.096.024.112.03.113.03.113.032.05.015.07.02.078.024.073.023.05.016.05.016.076.025.099.033.102.036.048.017.064.023.093.034.11.041.116.045.1.04.047.02.06.024.041.018.063.026.04.018.057.025.11.048.1.046.074.035.075.036.06.028.092.046.091.045.102.052.053.028.049.026.046.024.06.033.041.022.052.029.088.05.106.06.087.051.057.034.053.032.096.059.088.055.098.062.036.024.064.041.084.056.04.027.062.042.062.043.023.017c.054.037.108.075.161.114l.083.06.065.048.056.043.086.065.082.064.04.03.05.041.086.069.079.065.085.071c.712.6 1.353 1.283 1.909 2.031L7.222.994l.062-.027.065-.028.081-.034.086-.035c.113-.045.227-.09.341-.131l.096-.035.093-.033.084-.03.096-.031c.087-.03.176-.058.264-.085l.091-.027.086-.025.102-.03.085-.023.1-.026L9.04.37l.09-.023.091-.022.095-.022.09-.02.098-.021.091-.02.095-.018.092-.018.1-.018.091-.016.098-.017.092-.014.097-.015.092-.013.102-.013.091-.012.105-.012.09-.01.105-.01c.093-.01.186-.018.28-.024l.106-.008.09-.005.11-.006.093-.004.1-.004.097-.002.099-.002.197-.002z"></path>
  </svg>
);

const MiniMaxSVG = ({ height }: { height: number }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>MiniMax</title>
    <path d="M16.278 2c1.156 0 2.093.927 2.093 2.07v12.501a.74.74 0 00.744.709.74.74 0 00.743-.709V9.099a2.06 2.06 0 012.071-2.049A2.06 2.06 0 0124 9.1v6.561a.649.649 0 01-.652.645.649.649 0 01-.653-.645V9.1a.762.762 0 00-.766-.758.762.762 0 00-.766.758v7.472a2.037 2.037 0 01-2.048 2.026 2.037 2.037 0 01-2.048-2.026v-12.5a.785.785 0 00-.788-.753.785.785 0 00-.789.752l-.001 15.904A2.037 2.037 0 0113.441 22a2.037 2.037 0 01-2.048-2.026V18.04c0-.356.292-.645.652-.645.36 0 .652.289.652.645v1.934c0 .263.142.506.372.638.23.131.514.131.744 0a.734.734 0 00.372-.638V4.07c0-1.143.937-2.07 2.093-2.07zm-5.674 0c1.156 0 2.093.927 2.093 2.07v11.523a.648.648 0 01-.652.645.648.648 0 01-.652-.645V4.07a.785.785 0 00-.789-.78.785.785 0 00-.789.78v14.013a2.06 2.06 0 01-2.07 2.048 2.06 2.06 0 01-2.071-2.048V9.1a.762.762 0 00-.766-.758.762.762 0 00-.766.758v3.8a2.06 2.06 0 01-2.071 2.049A2.06 2.06 0 010 12.9v-1.378c0-.357.292-.646.652-.646.36 0 .653.29.653.646V12.9c0 .418.343.757.766.757s.766-.339.766-.757V9.099a2.06 2.06 0 012.07-2.048 2.06 2.06 0 012.071 2.048v8.984c0 .419.343.758.767.758.423 0 .766-.339.766-.758V4.07c0-1.143.937-2.07 2.093-2.07z" />
  </svg>
);

const PerplexitySVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Perplexity</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7849,0 L19.7849,7.272 L22.5,7.272 L22.5,17.62 L19.5651,17.62 L19.5651,24 L12.528,17.806 L12.528,23.9511 L11.437,23.9511 L11.437,17.7989 L4.392,24 L4.392,17.5349 L1.5,17.5349 L1.5,7.188 L4.384,7.188 L4.384,0 L11.437,6.494 L11.437,0.19 L12.527,0.19 L12.527,6.68 L19.7849,0 M12.528,9.044 L12.528,16.3631 L18.474,21.5971 L18.474,14.44 L12.528,9.044 M11.429,8.964 L5.483,14.362 L5.483,21.5971 L11.429,16.3631 L11.429,8.965 L11.429,8.964 M19.5651,16.544 L21.4091,16.544 L21.4091,8.349 L13.46,8.349 L19.5651,13.8889 L19.5651,16.544 M10.583,8.264 L2.59,8.264 L2.59,16.4589 L4.39,16.4589 L4.39,13.8831 L10.582,8.263 L10.583,8.264 M5.475,2.476 L5.475,7.186 L10.59,7.186 L5.475,2.476 M18.694,2.476 L13.5791,7.186 L18.694,7.186 L18.694,2.476"
      fill="currentColor"
    />
  </svg>
);

const TogetherSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Together</title>
    <g clipPath="url(#together-clip)">
      <path
        d="M23.1971,4.503 C22.8031,3.8205 22.2785,3.2224 21.6533,2.7427 C21.0281,2.2629 20.3145,1.9111 19.5533,1.7071 C18.7921,1.5032 17.9983,1.4512 17.2171,1.5542 C16.4357,1.6571 15.6824,1.9129 15,2.307 C14.1247,2.8093 13.3909,3.5252 12.8672,4.3878 C12.3435,5.2504 12.0468,6.2317 12.005,7.24 L18.0011,7.248 L18.0011,7.763 L12.005,7.763 C12.044,8.7 12.303,9.633 12.805,10.503 C13.191,11.2005 13.7121,11.814 14.3379,12.3079 C14.9636,12.8017 15.6815,13.1658 16.4496,13.3791 C17.2177,13.5924 18.0205,13.6504 18.8113,13.5499 C19.6021,13.4493 20.3649,13.1923 21.0552,12.7937 C21.7456,12.395 22.3495,11.8628 22.8319,11.2281 C23.3141,10.5935 23.6652,9.8691 23.8644,9.0972 C24.0636,8.3254 24.1069,7.5216 23.992,6.7328 C23.8771,5.9439 23.6061,5.1859 23.1951,4.503 L23.1971,4.503"
        fill="#EF2CC1"
      />
      <path
        d="M0.805,4.5 C0.4108,5.1823 0.155,5.9356 0.052,6.7169 C-0.051,7.4981 0.0009,8.292 0.2047,9.0531 C0.4085,9.8143 0.7603,10.5279 1.2399,11.1531 C1.7195,11.7783 2.3176,12.3029 3,12.697 C3.8727,13.204 4.8596,13.4816 5.8686,13.5037 C6.8777,13.526 7.8759,13.2921 8.77,12.824 L5.779,7.627 L6.225,7.37 L9.222,12.562 C9.9891,12.0737 10.6351,11.4174 11.1113,10.6427 C11.5875,9.868 11.8814,8.9953 11.9707,8.0903 C12.0601,7.1854 11.9426,6.272 11.6271,5.4192 C11.3117,4.5663 10.8065,3.7963 10.1498,3.1674 C9.4931,2.5384 8.702,2.067 7.8363,1.7886 C6.9706,1.5103 6.053,1.4324 5.1528,1.5607 C4.2526,1.6891 3.3933,2.0204 2.6399,2.5296 C1.8865,3.0388 1.2598,3.7126 0.805,4.5"
        fill="#CAAEF5"
      />
      <path
        d="M12,23.894 C13.5911,23.8937 15.1171,23.2615 16.242,22.1363 C17.3671,21.0111 17.9991,19.4851 17.9991,17.894 C17.9991,15.764 16.8991,13.898 15.224,12.834 L12.219,18.0231 L11.775,17.7651 L14.772,12.573 C13.9655,12.1528 13.0741,11.9214 12.165,11.8963 C11.256,11.8712 10.3531,12.0531 9.5247,12.4282 C8.6963,12.8033 7.9639,13.3617 7.383,14.0615 C6.8021,14.7612 6.3879,15.5837 6.1716,16.4671 C5.9553,17.3503 5.9427,18.2712 6.1346,19.1601 C6.3265,20.0491 6.7179,20.8828 7.2794,21.5981 C7.8408,22.3136 8.5575,22.892 9.3753,23.2897 C10.1931,23.6875 11.0906,23.8941 12,23.894"
        fill="#FC4C02"
      />
    </g>
    <defs>
      <clipPath id="together-clip">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ZAISVG = ({ height }: { height: number }) => (
  <svg
    fill="var(--global-text-color-900)"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Z.ai</title>
    <path d="M12.105 2L9.927 4.953H.653L2.83 2h9.276zM23.254 19.048L21.078 22h-9.242l2.174-2.952h9.244zM24 2L9.264 22H0L14.736 2H24z"></path>
  </svg>
);

const MetaSVG = ({ height }: { height: number }) => (
  <svg
    viewBox="0 0 24 24"
    width={height}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Meta</title>
    <path
      d="M6.897 4h-.024l-.031 2.615h.022c1.715 0 3.046 1.357 5.94 6.246l.175.297.012.02 1.62-2.438-.012-.019a48.763 48.763 0 00-1.098-1.716 28.01 28.01 0 00-1.175-1.629C10.413 4.932 8.812 4 6.896 4z"
      fill="url(#lobe-icons-meta-0)"
    ></path>
    <path
      d="M6.873 4C4.95 4.01 3.247 5.258 2.02 7.17a4.352 4.352 0 00-.01.017l2.254 1.231.011-.017c.718-1.083 1.61-1.774 2.568-1.785h.021L6.896 4h-.023z"
      fill="url(#lobe-icons-meta-1)"
    ></path>
    <path
      d="M2.019 7.17l-.011.017C1.2 8.447.598 9.995.274 11.664l-.005.022 2.534.6.004-.022c.27-1.467.786-2.828 1.456-3.845l.011-.017L2.02 7.17z"
      fill="url(#lobe-icons-meta-2)"
    ></path>
    <path
      d="M2.807 12.264l-2.533-.6-.005.022c-.177.918-.267 1.851-.269 2.786v.023l2.598.233v-.023a12.591 12.591 0 01.21-2.44z"
      fill="url(#lobe-icons-meta-3)"
    ></path>
    <path
      d="M2.677 15.537a5.462 5.462 0 01-.079-.813v-.022L0 14.468v.024a8.89 8.89 0 00.146 1.652l2.535-.585a4.106 4.106 0 01-.004-.022z"
      fill="url(#lobe-icons-meta-4)"
    ></path>
    <path
      d="M3.27 16.89c-.284-.31-.484-.756-.589-1.328l-.004-.021-2.535.585.004.021c.192 1.01.568 1.85 1.106 2.487l.014.017 2.018-1.745a2.106 2.106 0 01-.015-.016z"
      fill="url(#lobe-icons-meta-5)"
    ></path>
    <path
      d="M10.78 9.654c-1.528 2.35-2.454 3.825-2.454 3.825-2.035 3.2-2.739 3.917-3.871 3.917a1.545 1.545 0 01-1.186-.508l-2.017 1.744.014.017C2.01 19.518 3.058 20 4.356 20c1.963 0 3.374-.928 5.884-5.33l1.766-3.13a41.283 41.283 0 00-1.227-1.886z"
      fill="#0082FB"
    ></path>
    <path
      d="M13.502 5.946l-.016.016c-.4.43-.786.908-1.16 1.416.378.483.768 1.024 1.175 1.63.48-.743.928-1.345 1.367-1.807l.016-.016-1.382-1.24z"
      fill="url(#lobe-icons-meta-6)"
    ></path>
    <path
      d="M20.918 5.713C19.853 4.633 18.583 4 17.225 4c-1.432 0-2.637.787-3.723 1.944l-.016.016 1.382 1.24.016-.017c.715-.747 1.408-1.12 2.176-1.12.826 0 1.6.39 2.27 1.075l.015.016 1.589-1.425-.016-.016z"
      fill="#0082FB"
    ></path>
    <path
      d="M23.998 14.125c-.06-3.467-1.27-6.566-3.064-8.396l-.016-.016-1.588 1.424.015.016c1.35 1.392 2.277 3.98 2.361 6.971v.023h2.292v-.022z"
      fill="url(#lobe-icons-meta-7)"
    ></path>
    <path
      d="M23.998 14.15v-.023h-2.292v.022c.004.14.006.282.006.424 0 .815-.121 1.474-.368 1.95l-.011.022 1.708 1.782.013-.02c.62-.96.946-2.293.946-3.91 0-.083 0-.165-.002-.247z"
      fill="url(#lobe-icons-meta-8)"
    ></path>
    <path
      d="M21.344 16.52l-.011.02c-.214.402-.519.67-.917.787l.778 2.462a3.493 3.493 0 00.438-.182 3.558 3.558 0 001.366-1.218l.044-.065.012-.02-1.71-1.784z"
      fill="url(#lobe-icons-meta-9)"
    ></path>
    <path
      d="M19.92 17.393c-.262 0-.492-.039-.718-.14l-.798 2.522c.449.153.927.222 1.46.222.492 0 .943-.073 1.352-.215l-.78-2.462c-.167.05-.341.075-.517.073z"
      fill="url(#lobe-icons-meta-10)"
    ></path>
    <path
      d="M18.323 16.534l-.014-.017-1.836 1.914.016.017c.637.682 1.246 1.105 1.937 1.337l.797-2.52c-.291-.125-.573-.353-.9-.731z"
      fill="url(#lobe-icons-meta-11)"
    ></path>
    <path
      d="M18.309 16.515c-.55-.642-1.232-1.712-2.303-3.44l-1.396-2.336-.011-.02-1.62 2.438.012.02.989 1.668c.959 1.61 1.74 2.774 2.493 3.585l.016.016 1.834-1.914a2.353 2.353 0 01-.014-.017z"
      fill="url(#lobe-icons-meta-12)"
    ></path>
    <defs>
      <linearGradient
        id="lobe-icons-meta-0"
        x1="75.897%"
        x2="26.312%"
        y1="89.199%"
        y2="12.194%"
      >
        <stop offset=".06%" stopColor="#0867DF"></stop>
        <stop offset="45.39%" stopColor="#0668E1"></stop>
        <stop offset="85.91%" stopColor="#0064E0"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-1"
        x1="21.67%"
        x2="97.068%"
        y1="75.874%"
        y2="23.985%"
      >
        <stop offset="13.23%" stopColor="#0064DF"></stop>
        <stop offset="99.88%" stopColor="#0064E0"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-2"
        x1="38.263%"
        x2="60.895%"
        y1="89.127%"
        y2="16.131%"
      >
        <stop offset="1.47%" stopColor="#0072EC"></stop>
        <stop offset="68.81%" stopColor="#0064DF"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-3"
        x1="47.032%"
        x2="52.15%"
        y1="90.19%"
        y2="15.745%"
      >
        <stop offset="7.31%" stopColor="#007CF6"></stop>
        <stop offset="99.43%" stopColor="#0072EC"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-4"
        x1="52.155%"
        x2="47.591%"
        y1="58.301%"
        y2="37.004%"
      >
        <stop offset="7.31%" stopColor="#007FF9"></stop>
        <stop offset="100%" stopColor="#007CF6"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-5"
        x1="37.689%"
        x2="61.961%"
        y1="12.502%"
        y2="63.624%"
      >
        <stop offset="7.31%" stopColor="#007FF9"></stop>
        <stop offset="100%" stopColor="#0082FB"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-6"
        x1="34.808%"
        x2="62.313%"
        y1="68.859%"
        y2="23.174%"
      >
        <stop offset="27.99%" stopColor="#007FF8"></stop>
        <stop offset="91.41%" stopColor="#0082FB"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-7"
        x1="43.762%"
        x2="57.602%"
        y1="6.235%"
        y2="98.514%"
      >
        <stop offset="0%" stopColor="#0082FB"></stop>
        <stop offset="99.95%" stopColor="#0081FA"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-8"
        x1="60.055%"
        x2="39.88%"
        y1="4.661%"
        y2="69.077%"
      >
        <stop offset="6.19%" stopColor="#0081FA"></stop>
        <stop offset="100%" stopColor="#0080F9"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-9"
        x1="30.282%"
        x2="61.081%"
        y1="59.32%"
        y2="33.244%"
      >
        <stop offset="0%" stopColor="#027AF3"></stop>
        <stop offset="100%" stopColor="#0080F9"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-10"
        x1="20.433%"
        x2="82.112%"
        y1="50.001%"
        y2="50.001%"
      >
        <stop offset="0%" stopColor="#0377EF"></stop>
        <stop offset="99.94%" stopColor="#0279F1"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-11"
        x1="40.303%"
        x2="72.394%"
        y1="35.298%"
        y2="57.811%"
      >
        <stop offset=".19%" stopColor="#0471E9"></stop>
        <stop offset="100%" stopColor="#0377EF"></stop>
      </linearGradient>
      <linearGradient
        id="lobe-icons-meta-12"
        x1="32.254%"
        x2="68.003%"
        y1="19.719%"
        y2="84.908%"
      >
        <stop offset="27.65%" stopColor="#0867DF"></stop>
        <stop offset="100%" stopColor="#0471E9"></stop>
      </linearGradient>
    </defs>
  </svg>
);

const PROVIDER_ICONS: Record<
  ModelProvider,
  ({ height }: { height: number }) => React.ReactNode
> = {
  AZURE_OPENAI: AzureSVG,
  GOOGLE: GoogleSVG,
  OPENAI: OpenAISVG,
  ANTHROPIC: AnthropicSVG,
  DEEPSEEK: DeepSeekSVG,
  XAI: XAISVG,
  OLLAMA: OllamaSVG,
  AWS: BedrockSVG,
  CEREBRAS: CerebrasSVG,
  FIREWORKS: FireworksSVG,
  GROQ: GroqSVG,
  MOONSHOT: MoonshotSVG,
  MINIMAX: MiniMaxSVG,
  PERPLEXITY: PerplexitySVG,
  TOGETHER: TogetherSVG,
  ZAI: ZAISVG,
  META: MetaSVG,
};

export type GenerativeProviderIconProps = {
  provider: ModelProvider;
  height?: number;
};
/**
 * A component that renders an icon for a generative provider
 */
export function GenerativeProviderIcon({
  provider,
  height = 18,
}: GenerativeProviderIconProps) {
  return <span css={iconWrapCSS}>{PROVIDER_ICONS[provider]({ height })}</span>;
}
